'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import ReactUtilsPropTypes from 'react-utils/CustomPropTypes';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shallowCompare from 'react-addons-shallow-compare';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIBox from 'UIComponents/layout/UIBox';
import * as appSelectors from 'DesignData/selectors/app';
import * as globalWidgetsSelectors from 'DesignData/selectors/globalWidgets';
import * as GlobalWidgetsActions from 'DesignData/actions/GlobalWidgets';
import GlobalWidgetEditor from 'DesignEditorsUI/components/globalWidgetEditor/GlobalWidgetEditor';
import withGlobalWidget from 'DesignEditorsUI/components/globalWidgetEditor/decorators/withGlobalWidget';
import withBodyClass from 'DesignManagerIde/components/shared/hoc/withBodyClass';
import { compose } from 'redux';

function makeMapStateToProps() {
  const getPastEditHistoryCount = globalWidgetsSelectors.makeGetPastEditHistoryCount();
  const getFutureEditHistoryCount = globalWidgetsSelectors.makeGetFutureEditHistoryCount();
  return function mapStateToProps(state, props) {
    return {
      fetchError: globalWidgetsSelectors.getFetchError(state, props),
      globalWidgetId: props.assetId || appSelectors.getActiveGlobalWidgetId(state),
      isReadOnly: !!props.revisionId,
      pastEditHistoryCount: getPastEditHistoryCount(state, props),
      futureEditHistoryCount: getFutureEditHistoryCount(state, props)
    };
  };
}

const mapDispatchToProps = {
  undoGlobalWidgetEdit: GlobalWidgetsActions.undoEdit,
  redoGlobalWidgetEdit: GlobalWidgetsActions.redoEdit
};

class GlobalWidgetEditorContainer extends Component {
  constructor(...args) {
    super(...args);

    this.undoGlobalWidgetEdit = () => {
      if (!this.props.pastEditHistoryCount) {
        return;
      }

      this.props.undoGlobalWidgetEdit(this.props.globalWidgetId);
    };

    this.redoGlobalWidgetEdit = () => {
      if (!this.props.futureEditHistoryCount) {
        return;
      }

      this.props.redoGlobalWidgetEdit(this.props.globalWidgetId);
    };
  }

  componentDidMount() {
    const {
      globalWidgetId,
      isLoaded
    } = this.props;

    if (globalWidgetId && !isLoaded) {
      this.props.fetchGlobalWidget(globalWidgetId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      globalWidgetId
    } = prevProps;
    const {
      globalWidgetId: nextGlobalWidgetId,
      isLoaded: nextIsLoaded
    } = this.props;

    if (globalWidgetId !== nextGlobalWidgetId && nextGlobalWidgetId && !nextIsLoaded) {
      this.props.fetchGlobalWidget(nextGlobalWidgetId);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!nextProps.globalWidgetId) return false;
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    const {
      fetchError,
      globalWidgetId,
      isLoaded,
      isReadOnly,
      revisionId
    } = this.props;

    if (!isLoaded) {
      if (fetchError) {
        return /*#__PURE__*/_jsx(NavMarker, {
          name: "GLOBAL_MODULE_EDITOR_ERROR",
          children: /*#__PURE__*/_jsx(UIBox, {
            grow: 1,
            children: /*#__PURE__*/_jsx(UIErrorMessage, {
              title: unescapedText('designManager.errorPages.loadingErrors.globalWidgetEditor.title'),
              type: "badRequest",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "designManager.errorPages.loadingErrors.globalWidgetEditor.message"
              })
            })
          })
        });
      }

      return /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true
      });
    }

    return /*#__PURE__*/_jsx(NavMarker, {
      name: "GLOBAL_MODULE_EDITOR",
      children: /*#__PURE__*/_jsx(GlobalWidgetEditor, {
        globalWidgetId: globalWidgetId,
        revisionId: revisionId,
        isReadOnly: isReadOnly,
        undoGlobalWidgetEdit: this.undoGlobalWidgetEdit,
        redoGlobalWidgetEdit: this.redoGlobalWidgetEdit
      })
    });
  }

}

GlobalWidgetEditorContainer.propTypes = {
  revisionId: PropTypes.number,
  // connect()
  globalWidgetId: PropTypes.number,
  isLoaded: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  fetchError: PropTypes.instanceOf(Error),
  fetchGlobalWidget: PropTypes.func.isRequired,
  // Undo/Redo
  pastEditHistoryCount: ReactUtilsPropTypes.uint32.isRequired,
  futureEditHistoryCount: ReactUtilsPropTypes.uint32.isRequired,
  undoGlobalWidgetEdit: PropTypes.func.isRequired,
  redoGlobalWidgetEdit: PropTypes.func.isRequired
};
export default compose(withBodyClass('global-widget-editor--is_active'), connect(makeMapStateToProps, mapDispatchToProps), withGlobalWidget())(GlobalWidgetEditorContainer);